module.exports = __webpack_public_path__ + "static/media/thiago.a3b91e01.jpg";